<mat-card class="content-card">
  <app-mat-table-generator #table 
      tableName = "customerTable"
      [columns] ="columns"
      [dataSource] ="dataSource"
      [viewLink]="getViewLink" 
      [editLink]="getEditLink"
      [editEnabled]="editEnabled()"
      [deleteEnabled]="deleteEnabled()"
      [multiselectEnabled]="deleteEnabled()"
  >
  </app-mat-table-generator>
</mat-card>